import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en_navbar from './en/navbar.json';
import id_navbar from './id/navbar.json';
import en_home from './en/home.json';
import id_home from './id/home.json';
import en_faq from './en/faq.json';
import id_faq from './id/faq.json';
import en_portfolio from './en/portfolio.json';
import id_portfolio from './id/portfolio.json';
import en_alumni from './en/alumni.json';
import id_alumni from './id/alumni.json';
import en_testimony from './en/testimony.json';
import id_testimony from './id/testimony.json';
import en_career from './en/career.json';
import id_career from './id/career.json';
import en_corporate from './en/corporate.json';
import id_corporate from './id/corporate.json';
import en_success from './en/success.json';
import id_success from './id/success.json';
import en_checkout from './en/checkout.json';
import id_checkout from './id/checkout.json';
import en_public_tainring from './en/public-training.json';
import id_public_tainring from './id/public-training.json';
import en_bootcamp from './en/bootcamp.json';
import id_bootcamp from './id/bootcamp.json';
import en_event from './en/event.json';
import id_event from './id/event.json';
import en_prakerja from './en/prakerja.json';
import id_prakerja from './id/prakerja.json';
import en_about_us from './en/about-us.json';
import id_about_us from './id/about-us.json';
import en_contact_us from './en/contact-us.json';
import id_contact_us from './id/contact-us.json';
import en_corp_collab from './en/corporate-collab.json';
import id_corp_collab from './id/corporate-collab.json';
import en_corporate_acceleration from './en/corporate-acceleration.json';
import id_corporate_acceleration from './id/corporate-acceleration.json';
import en_corporate_training from './en/corporate-training.json';
import id_corporate_training from './id/corporate-training.json';
import en_talent_service from './en/talent-service.json';
import id_talent_service from './id/talent-service.json';
import en_tech_service from './en/tech-service.json';
import id_tech_service from './id/tech-service.json';
import en_kampus_merdeka from './en/kampus-merdeka.json';
import id_kampus_merdeka from './id/kampus-merdeka.json';

Vue.use(VueI18n);

const messages = {
    en: {
      ...en_navbar,
      ...en_faq,
      ...en_home,
      ...en_about_us,
      ...en_contact_us,
      ...en_portfolio,
      ...en_alumni,
      ...en_testimony,
      ...en_career,
      ...en_corporate,
      ...en_corporate_acceleration,
      ...en_corp_collab,
      ...en_corporate_training,
      ...en_talent_service,
      ...en_tech_service,
      ...en_success,
      ...en_checkout,
      ...en_prakerja,
      ...en_event,
      ...en_kampus_merdeka,
      ...en_bootcamp,
      ...en_public_tainring,
    },
    id: {
      ...id_navbar,
      ...id_faq,
      ...id_home,
      ...id_about_us,
      ...id_contact_us,
      ...id_alumni,
      ...id_portfolio,
      ...id_testimony,
      ...id_career,
      ...id_corporate,
      ...id_corporate_acceleration,
      ...id_corp_collab,
      ...id_corporate_training,
      ...id_talent_service,
      ...id_tech_service,
      ...id_success,
      ...id_checkout,
      ...id_prakerja,
      ...id_event,
      ...id_bootcamp,
      ...id_public_tainring,
      ...id_kampus_merdeka
    }
  };

const i18n = new VueI18n({
  locale: "id", 
  fallbackLocale: "id", 
  messages
});

export default i18n;